import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

import { OccupationMicroService } from '@cpd-app/core-module/services';
import { OccupationQuickMatchModel } from '@cpd-app/core-module/models';

import * as OccupationActions from './occupation.actions';
import { ErrorReceived } from '../error/error.actions';

@Injectable()
export class OccupationEffects {
  constructor(
    private actions$: Actions,
    private occupationMicroService: OccupationMicroService
  ) {}

  public requestOccupationsByDemandList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(OccupationActions.requestOccupationsByDemandList),
      switchMap(() => {
        return this.occupationMicroService.getOccupationListByDemand().pipe(
          map((occupationList: OccupationQuickMatchModel[]) =>
            OccupationActions.receivedOccupationsByDemandList({
              entities: occupationList
            })
          ),
          /*
           * `{ error }`, not `error`. ErrorReceived takes props<{ error }>, so
           * passing the error itself put its OWN keys on the action and left
           * `action.error` undefined: the real failure was discarded and the
           * page showed a bare "An error occurred" with nothing behind it.
           * That is also why the authorization filter could not recognize the
           * Forbidden this reports.
           */
          catchError((error) => of(ErrorReceived({ error })))
        );
      })
    );
  });

  public requestMilitaryFriendlyOccupationsList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(OccupationActions.requestMilitaryFriendlyOccupationsList),
      switchMap(() => {
        return this.occupationMicroService
          .getMilitaryFrienldyOccupationsList()
          .pipe(
            map((occupationList: OccupationQuickMatchModel[]) =>
              OccupationActions.receivedMilitaryFriendlyOccupationsList({
                entities: occupationList
              })
            ),
            catchError((error) => of(ErrorReceived({ error })))
          );
      })
    );
  });
}
